<template>
  <section :class="['terms ', userDetails.msisdn === '' ? 'logged_out' : '']">
    <div class="terms__header">
      <h1>{{ getTranslations.home_terms_terms_of_conditions }}</h1>
      <p>{{ getTranslations.home_terms_p_1 }}<br>{{ getTranslations.home_terms_p_2 }}</p>
    </div>
    <div class="terms__content">
      <div class="terms__content__item">
        <h2>{{ getTranslations.home_terms_description_of_service }}</h2>
        <p>{{ getTranslations.home_terms_service_p_1 }}</p>
        <p>
          {{ getTranslations.home_terms_service_p_2 }}</p>
      </div>
      <div class="terms__content__item">
        <h2>{{ getTranslations.home_terms_description_of_service }}</h2>
        <p>{{ getTranslations.home_terms_service_p_1 }}</p>
        <p>
          {{ getTranslations.home_terms_service_p_2 }}</p>
      </div>
      <div class="terms__content__item">
        <h2>{{ getTranslations.home_terms_description_of_service }}</h2>
        <p>{{ getTranslations.home_terms_service_p_1 }}</p>
        <p>
          {{ getTranslations.home_terms_service_p_2 }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'terms',

  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Terms.vue